import {
    SHOW_NEXT_BUTTON, HIDE_NEXT_BUTTON
} from '../constants';


export function showNextButton(obj) {
    return {
        type: SHOW_NEXT_BUTTON,
        payload: {
          link: obj.link,
          watch: obj.watch,
          label: obj.label,
          addText: obj.addText,
          submitDelay: (obj.submitDelay!==undefined?obj.submitDelay:0)
        }
    }
}
export function hideNextButton() {
    return {
        type: HIDE_NEXT_BUTTON,
        payload: {}
    }
}




// WEBPACK FOOTER //
// ./src/actions/next.js